import {
  faInr,
  faBuildingColumns,
  faCreditCard,
  faMoneyCheck,
  faCircleInfo 
} from "@fortawesome/free-solid-svg-icons";
import { IoMdPrint } from "react-icons/io";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { Button, Col, Modal, Row, Spinner } from "react-bootstrap";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import billsService from "../../services/customer-services/bills-payments-service"; // Import billsService
import { toast } from "react-toastify"; // Import ToastContainer and toast
import "react-toastify/dist/ReactToastify.css";
import { usePrint } from "print-react-component"; // Import usePrint
import personalInfoServices from "../../services/customer-services/profile-personal-info";
import Logo from "../../assets/images/WeRentt-final-logo.png";
import { handleErrors } from "../../utils/errorHandler";
import { useNavigate } from "react-router-dom";
import PaymentBreakdownModal from "../common/PaymentBreakDown";
// to download the file for the pdf
import html2pdf from "html2pdf.js";
import { checkIsMobile } from "../../utils/helpers";
import { IoIosCloudDownload } from "react-icons/io";

const BillsPayments = ({ rowData }) => {
  const navigate = useNavigate();

  const [billData, setBillData] = useState([]);
  const [isProcessing, setIsProcessing] = useState(false);
  const [activeMethod, setActiveMethod] = useState("");
  // Reference to the receipt container
  const [receiptData, setReceiptData] = useState([]); // State for receipts
  // Initialize the navigate function
  const { holder, printReactNode } = usePrint(); // usePrint hook
  const [profileData, setProfileData] = useState(null);
  const [loadingBills, setLoadingBills] = useState(false);
  const [selectedBill, setSelectedBill] = useState(null);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [selectedMethod, setSelectedMethod] = useState(null);
//this is  to show the Payment breaDown Modal 
  const [showPaymentBreakdownModal, setShowPaymentBreakdownModal] = useState(false);
  const[selectedPaymentDetails, setSelectedPaymentDetails] = useState({});
  // states to handle is mobile or not.
  const [isMobile, setIsMobile] = useState(false);

  // === Payment Methods Config (same as Checkout) ===
  const methodMap = {
    credit: "credit",
    debit: "debit",
    "net banking": "netbanking",
    upi: "upi",
  };

  const methodConfig = {
    credit: [{ method: "card", types: ["credit"] }],
    debit: [{ method: "card", types: ["debit"] }],
    upi: [{ method: "upi" }],
    netbanking: [{ method: "netbanking" }],
  };

  useEffect(() => {
    const isMobile = checkIsMobile();
    setIsMobile(isMobile);
  }, []);

  useEffect(() => {
    async function fetchProfile() {
      try {
        const response = await personalInfoServices.getProfileInfo();
        if (response.data.isSuccess) {
          setProfileData(response.data.result); // Set the profile data
        }
      } catch (error) {
        const errorMessage = handleErrors(error);
        toast.error(errorMessage);
      }
    }

    fetchProfile();
  }, []);

  useEffect(() => {
    fetchBillsData();
    fetchReceiptsData();
  }, []);

  // Helper function to format dates as "Jan-11-2024"
  const handlePaymentWithLoader = async (bill, method) => {
    setActiveMethod(method);
    setIsProcessing(true);

    try {
      await handlePayment(bill, method); // your existing payment call
    } catch (error) {
      console.error("Payment failed:", error);
    } finally {
      setIsProcessing(false);
      setActiveMethod("");
    }
  };
  const formatDateTime = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = date.toLocaleString("en-GB", { month: "short" });
    const year = date.getFullYear();
    let hour = date.getHours();
    const minute = String(date.getMinutes()).padStart(2, "0");
    const ampm = hour >= 12 ? "pm" : "am";
    hour = hour % 12;
    hour = hour ? String(hour).padStart(2, "0") : "12";

    return `${day}-${month}-${year} ${hour}:${minute} ${ampm}`;
  };

  const statusBodyTemplate = (rowData) => {
    if (rowData.paymentStatus === "Success") {
      return <span className="badge badge-success">Success</span>;
    } else if (rowData.paymentStatus === "Initiated") {
      return <span className="badge badge-warning">Initiated</span>;
    }
    return rowData.paymentStatus; // Default text if status does not match
  };

  function loadScript(src) {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = src;
      script.onload = () => {
        resolve(true);
      };
      script.onerror = () => {
        resolve(false);
      };
      document.body.appendChild(script);
    });
  }

  const fetchBillsData = async () => {
    setLoadingBills(true);
    try {
      const response = await billsService.getBillsPayment();
      if (response.data.isSuccess) setBillData(response.data.result || []);
    } catch (error) {
      toast.error(handleErrors(error));
    } finally {
      setLoadingBills(false);
    }
  };

  const fetchReceiptsData = async () => {
    try {
      const response = await billsService.getReceipts();
      if (response.data.isSuccess) setReceiptData(response.data.result);
    } catch (error) {
      toast.error(handleErrors(error));
    }
  };

  useEffect(() => {
    fetchBillsData();
    fetchReceiptsData();
    personalInfoServices.getProfileInfo().then((response) => {
      if (response.data.isSuccess) setProfileData(response.data.result);
    });
  }, []);

  // === Helpers ===
  const formatDate = (date) => {
    if (!date) return "";
    const options = { day: "2-digit", month: "short", year: "numeric" };
    return new Date(date)
      .toLocaleDateString("en-GB", options)
      .replace(/ /g, "-");
  };

  function loadScript(src) {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = src;
      script.onload = () => resolve(true);
      script.onerror = () => resolve(false);
      document.body.appendChild(script);
    });
  }

  // === Common Razorpay Payment Handler ===
  const handlePayment = async (bill, method) => {
    const actualMethod = methodMap[method] || method;
    try {
      const paymentRequest = await billsService.createPendingPaymentRequest(
        bill.orderGuid,
        method,
      );
      const paymentRequestDetails = paymentRequest.data.result;

      const res = await loadScript(
        "https://checkout.razorpay.com/v1/checkout.js",
      );
      if (!res) {
        toast.error("Razorpay SDK failed to load.");
        return;
      }

      const options = {
        key: "rzp_live_IK45l8N7fWxa6F",
        // key: "rzp_test_obKqWxOCW5u38m",
        amount: paymentRequestDetails.pendingAmount * 100,
        currency: "INR",
        name: "WeRentt",
        description: `${bill.billType || "Bill"} Payment`,
        image:
          "https://www.werentt.com/static/media/WeRentt-final-logo.a083162ce9c049834180.png",
        order_id: paymentRequestDetails.orderPaymentId,
        handler: async (response) => {
          const data = {
            OrderGuid: bill.orderGuid,
            razorpay_payment_id: response.razorpay_payment_id,
            razorpay_order_id: response.razorpay_order_id,
            razorpay_signature: response.razorpay_signature,
            razorpay_mode: method,
          };
          try {
            const result = await billsService.updatePendingPaymentStatus(data);
            if (result.data.isSuccess) {
              toast.success(`${bill.billType || "Bill"} Payment Successful!`);
              fetchBillsData();
              fetchReceiptsData();
            } else {
              toast.error("Payment verification failed.");
            }
          } catch (error) {
            toast.error(handleErrors(error));
          }
        },
        prefill: {
          name: paymentRequestDetails.userName,
          email: paymentRequestDetails.emailAddress,
          contact: paymentRequestDetails.contactNo,
        },
        theme: {
          color: "#61dafb",
        },
        config: {
          display: {
            blocks: {
              main: {
                name: `Pay using ${
                  method.charAt(0).toUpperCase() + method.slice(1)
                }`,
                instruments: methodConfig[actualMethod] || [],
              },
            },
            sequence: ["block.main"],
            preferences: { show_default_blocks: false },
          },
        },
      };

      const paymentObject = new window.Razorpay(options);
      paymentObject.open();
    } catch (error) {
      toast.error(handleErrors(error));
    } finally {
      setShowPaymentModal(false);
    }
  };
  const groupedBills = billData.reduce((acc, bill) => {
    const { orderGuid, flatNo } = bill;

    // Extract month from any available section (rent, utility, etc.)
    const fromDate =
      bill.rents?.[0]?.fromDate ||
      bill.utilities?.[0]?.fromDate ||
      bill.maintenance?.[0]?.fromDate ||
      bill.oItems?.[0]?.fromDate;

    // Generate monthName like "Sept-2025"
    const monthName = fromDate
      ? new Date(fromDate).toLocaleString("en-US", {
          month: "short",
          year: "numeric",
        })
      : "";

    if (!acc[orderGuid]) {
      acc[orderGuid] = {
        orderGuid,
        flatNo,
        monthName,
        totalAmount: 0,
        paymentDetails: {},
      };
    }

    // Totals
    const rentTotal =
      bill.rents?.reduce((t, r) => t + (r.currentRentAmount || 0), 0) || 0;
    const utilityTotal =
      bill.utilities?.reduce((t, u) => t + (u.totalAmount || 0), 0) || 0;
    const otherTotal =
      bill.oItems?.reduce((t, i) => t + (i.totalAmount || 0), 0) || 0;
    const maintenanceTotal =
      bill.maintenance?.reduce((t, m) => t + (m.totalAmount || 0), 0) || 0;

    acc[orderGuid].totalAmount +=
      rentTotal + utilityTotal + otherTotal + maintenanceTotal;
//here We changed the Logic to >= because we have to display all the  breakdown
// and chnage the payment Details from array to the object
    if (rentTotal >= 0)
      acc[orderGuid].paymentDetails.rent = `${rentTotal.toFixed(2)}`;
    if (utilityTotal >= 0)
      acc[orderGuid].paymentDetails.utility = `${utilityTotal.toFixed(2)}`;
    if (maintenanceTotal >= 0)
      acc[orderGuid].paymentDetails.maintenance = `${maintenanceTotal.toFixed(2)}`;
    if (otherTotal >= 0)
      acc[orderGuid].paymentDetails.other = `${otherTotal.toFixed(2)}`;

    return acc;
  }, {});

  const groupedBillArray = Object.values(groupedBills);
// console.log("groupedBillArray", groupedBillArray);
/**
 * @param {*} item 
 * @returns selectectPaymentDetails data
 */
const handlePaymentBreakdown = (item) => {
  setSelectedPaymentDetails(item);
  setShowPaymentBreakdownModal(true);
}





  const renderBillCard = (title, item, amountKey, dateKey) => (
    <div className="bill-details__col">
      <div className="card">
        <div className="bill-info-wrap">
          <div className="bill-name">{title}</div>
          <div className="bill-info">{formatDate(item[dateKey])}</div>
        </div>
        <div className="bill-amount">
          <FontAwesomeIcon icon={faInr} /> {item[amountKey] || "0"}
        </div>
        <div className="pay-bill">
          <Button
            className="btn-theme-blue py-1"
            onClick={() => {
              setSelectedBill(item);
              setShowPaymentModal(true);
            }}
          >
            Pay Now
          </Button>
        </div>
      </div>
    </div>
  );

  return (
    <div className="bill-payment-wrapper">
      {holder}
      <div className="my-account-title">
        <h2>Bills & Payments</h2>
      </div>
      <div className="bill-detail-content">
        {loadingBills ? (
          <div style={{ textAlign: "center", margin: "8px 0" }}>
            <Spinner animation="border" variant="primary" />
          </div>
        ) : groupedBillArray.length === 0 ? (
          <div style={{ textAlign: "center", padding: "16px" }}>
            <h6 style={{ color: "#999", fontWeight: "500" }}>
              No pending Bills
            </h6>
          </div>
        ) : (
          <div className="bill-details__row">
            {groupedBillArray.map((bill, index) => (
              <div
                key={index}
                style={{
                  backgroundColor: "#fff",
                  borderRadius: "12px",
                  boxShadow: "0 2px 6px rgba(0,0,0,0.4)",
                  margin: "12px 0",
                  padding: "16px",
                }}
              >
                {/* Header */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                  }}
                >
                  <div>
                    <p
                      style={{
                        fontSize: "13px",
                        color: "#777",
                        marginBottom: "4px",
                      }}
                    >
                      Month
                    </p>
                    <h5
                      style={{
                        color: "#004aad",
                        fontWeight: "700",
                        fontSize: "16px",
                        margin: 0,
                      }}
                    >
                      {bill.monthName}
                    </h5>
                  </div>

                  <div>
                    <p
                      style={{
                        fontSize: "13px",
                        color: "#777",
                        marginBottom: "4px",
                      }}
                    >
                      Payment For
                    </p>
                    <h5
                      style={{
                        fontWeight: "500",
                        color: "#000",
                        fontSize: "16px",
                        margin: 0,
                      }}
                    >
                      Total Bill Of Flat No-{bill.flatNo}
                    </h5>
                  </div>
                </div>

                {/* Body */}
                {/* <div style={{ marginTop: "10px" }}>
                  <p
                    style={{
                      color: "#666",
                      fontSize: "14px",
                      marginBottom: "10px",
                    }}
                  >
                    Payment Info :
                  </p>
                  <p
                    style={{
                      color: "#007f5f",
                      fontSize: "14px",
                      margin: 0,
                    }}
                    title={bill.paymentDetails.join(" + ")}
                  >
                    {bill.paymentDetails.length > 2
                      ? bill.paymentDetails.slice(0, 2).join(" + ") + " ..."
                      : bill.paymentDetails.join(" + ")}
                  </p>
                </div> */}

                {/* Footer */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginTop: "16px",
                    borderTop: "2px solid #eee",
                    paddingTop: "12px",
                  }}
                >
                  <span
                    style={{
                      fontWeight: "700",
                      marginTop: "8px",
                      fontSize: "20px",
                      color: "#000",
                      cursor: "pointer",
                  
                    }}
                    onClick={() => handlePaymentBreakdown(bill)}
                    className="d-flex align-items-center"
                  >
                    ₹{bill.totalAmount.toLocaleString("en-IN")}

                    <span className="ms-2" 
                    style={{
                      fontSize: "18px",
                      color: "#848383",
                    }}
                    title="Click to view payment breakdown ">
                      <FontAwesomeIcon
  icon={faCircleInfo}
  style={{ cursor: "pointer" }}
/>
                    </span>
                  </span>
                  <button
                    onClick={() => {
                      setSelectedBill(bill);
                      setShowPaymentModal(true);
                    }}
                    style={{
                      backgroundColor: "#000",
                      color: "#fff",
                      border: "none",
                      borderRadius: "8px",
                      padding: "8px 18px",
                      fontSize: "14px",
                      cursor: "pointer",
                    }}
                  >
                    Pay
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      <Modal
        show={showPaymentModal}
        onHide={() => setShowPaymentModal(false)}
        centered
        className="payment-method-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Select Payment Method</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {selectedBill ? (
            <div className="choose-payment-method">
              {["credit", "debit", "net banking", "upi"].map((method) => {
                const amount =
                  selectedBill.currentRentAmount ||
                  selectedBill.utilityAmount ||
                  selectedBill.totalAmount ||
                  selectedBill.maintenanceAmount ||
                  0;

                const isCard = method === "credit" || method === "debit";
                const chargePercent = isCard ? 1.6 : 0.25;
                const totalAmount = (
                  amount *
                  (1 + chargePercent / 100)
                ).toFixed(2);
                const extraCharge = ((amount * chargePercent) / 100).toFixed(2);

                return (
                  <div
                    key={method}
                    className="payment-options"
                    onClick={() =>
                      handlePaymentWithLoader(selectedBill, method)
                    }
                    style={{
                      opacity:
                        isProcessing && activeMethod !== method ? 0.6 : 1,
                      pointerEvents:
                        isProcessing && activeMethod !== method
                          ? "none"
                          : "auto",
                      position: "relative",
                    }}
                  >
                    <div className="payment-title">
                      {method === "net banking" ? (
                        <FontAwesomeIcon icon={faBuildingColumns} />
                      ) : method === "upi" ? (
                        <FontAwesomeIcon icon={faMoneyCheck} />
                      ) : (
                        <FontAwesomeIcon icon={faCreditCard} />
                      )}{" "}
                      {method.charAt(0).toUpperCase() + method.slice(1)}
                    </div>

                    <div className="payment-amount-note">
                      <span className="exact-amount-to-pay">
                        <FontAwesomeIcon icon={faInr} /> {totalAmount}
                      </span>
                      <span className="additional-charges">
                        <FontAwesomeIcon icon={faInr} /> {extraCharge}{" "}
                        Transaction Charges
                      </span>
                    </div>

                    {/* ✅ Spinner inside clicked button */}
                    {isProcessing && activeMethod === method && (
                      <div
                        style={{
                          position: "absolute",
                          top: "50%",
                          left: "50%",
                          right: "15px",
                          transform: "translateY(-50%)",
                        }}
                      >
                        <Spinner
                          animation="border"
                          size="sm"
                          variant="primary"
                        />
                      </div>
                    )}
                  </div>
                );
              })}

              <div className="alert alert-warning mt-3">
                <div className="payment-note">
                  <h6>Please Note</h6>
                  <ul>
                    <li>
                      1.6% including GST applies on payments via Credit/Debit
                      Card.
                    </li>
                    <li>0.25% including GST applies on other payment modes.</li>
                  </ul>
                  <p>
                    Charges are as per payment gateway policy. Thank you for
                    understanding.
                  </p>
                </div>
              </div>
            </div>
          ) : (
            <p className="text-center text-muted">No bill selected.</p>
          )}
        </Modal.Body>
      </Modal>

      <Row>
        <Col>
          <div className="renewal-property ">
            <div className="my-account-subtitle">
              <h3>Receipts</h3>
            </div>

            <DataTable
              value={receiptData}
              paginator
              rows={10}
              showGridlines
              stripedRows
            >
              <Column
                header="Property"
                body={(rowData) => (
                  <div>
                    <div>
                      <b>{rowData.propertyName}</b>
                    </div>
                    <small>
                      <i>
                        {formatDate(rowData.fromDate)} to{" "}
                        {formatDate(rowData.toDate)}
                      </i>
                    </small>
                  </div>
                )}
              />
              <Column field="itemName" header="Remark" />
              <Column
                field="amount"
                header="Amount"
                body={(rowData) => (
                  <div>
                    <FontAwesomeIcon icon={faInr} /> {/* INR Icon */}
                    {rowData.amount}
                  </div>
                )}
              />
              <Column
                field="paymentStatus"
                header="Status"
                body={statusBodyTemplate}
              />
              <Column
                header="Payment Id"
                body={(rowData) => (
                  <div>
                    <div className="text-success">{`${rowData.paymentId}`}</div>
                    <small>{`${formatDateTime(rowData.paidOn)}`}</small>
                  </div>
                )}
              />
              <Column
                field="receipt"
                header="Receipt"
                body={(rowData) => {
                  if (rowData.paymentStatus !== "Success") return null;

                  // 1. Create a unique ID for this specific row's receipt
                  const receiptId = `receipt-${rowData.paymentId}`;

                  const component = (
                    <div
                      id={receiptId}
                      style={{
                        minHeight: "100vh",
                        display: "flex",
                        flexDirection: "column",
                        background: "white",
                        position: "relative",
                      }}
                    >
                      <div className="main-wrapper">
                        <div className="container">
                          <div className="row justify-content-center">
                            <div className="col-xl-9 col-md-8">
                              <div className="settings-widget profile-details mar-top-20">
                                <div className="settings-menu invoice-list-blk p-0">
                                  <div className="card pro-post border-0 mb-0">
                                    <div className="card-body">
                                      <div className="invoice-item">
                                        <div className="col-md-12 text-end d-flex justify-content-end">
                                          <div></div>
                                          <div className="invoice-logo">
                                            <img
                                              src={Logo}
                                              className="img-fluid"
                                              alt="Logo"
                                            />
                                          </div>
                                        </div>
                                        <div
                                          className="wrapper-payment"
                                          // style={{ width: "100%" }}
                                        >
                                          <div>
                                            <div className="invoice-item">
                                              <div className="row">
                                                <div className="col-md-12">
                                                  <div className="bg-light-gray-2 p-2 mb-1">
                                                    <span>
                                                      <strong>
                                                        Receipt Date:
                                                      </strong>{" "}
                                                      {formatDate(
                                                        rowData.updatedOn,
                                                      )}
                                                    </span>
                                                    <br />
                                                    <span>
                                                      <strong>Status:</strong>{" "}
                                                      Paid
                                                    </span>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            {profileData && (
                                              <div className="invoice-item">
                                                <div className="row">
                                                  <div className="col-md-12">
                                                    <div className="bg-light-gray-2 p-2 mb-3">
                                                      <h5>Billing Info</h5>
                                                      <p>
                                                        <strong>Name:</strong>{" "}
                                                        {profileData.firstName}{" "}
                                                        {profileData.lastName}
                                                        <br />
                                                        <strong>
                                                          Email:
                                                        </strong>{" "}
                                                        {
                                                          profileData.emailAddress
                                                        }
                                                        <br />
                                                        <strong>
                                                          Phone:
                                                        </strong>{" "}
                                                        {profileData.phoneNo}
                                                      </p>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            )}
                                          </div>
                                          <div
                                            className="col-md-6"
                                            style={{
                                              width: "50%",
                                            }}
                                          >
                                            <p className="invoice-details mb-3">
                                              <strong>
                                                #238/239, 2nd floor, Raheja
                                                Arcade, Koramangala, Bangalore,
                                                Karnataka-560095
                                              </strong>
                                              <br />
                                              <strong>Email:</strong>{" "}
                                              helpdesk@sowerent.com
                                              <br />
                                            </p>
                                          </div>
                                        </div>
                                      </div>

                                      <div className="invoice-item invoice-table-wrap">
                                        <div className="row">
                                          <div className="col-md-12">
                                            <div className="table-responsive">
                                              <table className="invoice-table table table-bordered">
                                                <thead>
                                                  <tr>
                                                    <th>Property</th>
                                                    <th>Period</th>
                                                    <th>Payment ID</th>
                                                    <th className="text-center">
                                                      Paid on
                                                    </th>
                                                    <th className="text-end">
                                                      Amount
                                                    </th>
                                                  </tr>
                                                </thead>
                                                <tbody>
                                                  <tr>
                                                    <td>
                                                      {rowData.propertyName} -
                                                      Flat No- {rowData.flatNo}
                                                    </td>
                                                    <td>
                                                      {formatDate(
                                                        rowData.fromDate,
                                                      )}{" "}
                                                      to{" "}
                                                      {formatDate(
                                                        rowData.toDate,
                                                      )}
                                                    </td>
                                                    <td
                                                      style={{
                                                        color: "green",
                                                      }}
                                                    >
                                                      {rowData.paymentId}
                                                    </td>
                                                    <td className="text-center">
                                                      {formatDate(
                                                        rowData.paidOn,
                                                      )}
                                                    </td>
                                                    <td className="text-end">
                                                      ₹{rowData.amount}
                                                    </td>
                                                  </tr>
                                                </tbody>
                                              </table>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <footer
                        className="invoice-footer text-center p-3 bg-light"
                        style={{
                          marginTop: "auto",
                        }}
                      >
                        <p>
                          Thank you for your payment, this is a
                          computer-generated receipt , does not require
                          signature!
                          <br />
                          <strong>SoWeRent Technology LLP</strong>
                        </p>
                      </footer>
                    </div>
                  );

                  return (
                    <div className="receipt-pdf-wrapper">
                      {isMobile ? (
                        <span
                          onClick={() => {
                            const element = document.getElementById(receiptId);
                            html2pdf()
                              .from(element)
                              .save(`receipt-${rowData.paymentId}.pdf`);
                            toast.success(
                              "Your receipt has been saved successfully...!",
                            );
                          }}
                          className="cursor-pointer"
                        >
                          <IoIosCloudDownload size={20} />
                        </span>
                      ) : (
                        <IoMdPrint
                          style={{
                            cursor: "pointer",
                            width: "50px",
                            fontSize: "30px",
                          }}
                          onClick={() => printReactNode(component)}
                        />
                      )}

                      {/*  We must render the component but keep it hidden from the UI */}
                      <div style={{ display: "none" }}>{component}</div>
                    </div>
                  );
                }}
              />
            </DataTable>
          </div>
        </Col>
      </Row>
      {selectedPaymentDetails  && (
       <PaymentBreakdownModal
        paymentDetails={selectedPaymentDetails?.paymentDetails}
        total={selectedPaymentDetails?.totalAmount}
        isOpen={showPaymentBreakdownModal}
        onClose={() => setShowPaymentBreakdownModal(false)}
      />
      )}
    </div>
  );
};

export default BillsPayments;
